import { FormHelperText } from '@material-ui/core';
import React from 'react';

interface ErrorTextProps {
  error: boolean;
  errorText: string;
}
export default function ErrorText(props: ErrorTextProps): JSX.Element | null {
  const { error, errorText } = props;

  if (error) {
    return (
      <FormHelperText id="text-entry-error" error>
        {errorText}
      </FormHelperText>
    );
  }

  return null;
}
